import { render, staticRenderFns } from "./WidgetSubscriptions.vue?vue&type=template&id=3079dd84"
import script from "./WidgetSubscriptions.vue?vue&type=script&lang=js"
export * from "./WidgetSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports